import React from 'react';
import './index.css'
import PostList from './components/PostList';
function App() {

  return <PostList/>
}

export default App
